"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperPropertyArrayItem = void 0;
const vue_1 = require("vue");
const WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
/**
 * obiekt reprezentujący element tablciy
 *
 * @export
 * @class WrapperPropertyArrayItem
 * @implements {IWrapperPropertyArrayItem}
 */
class WrapperPropertyArrayItem {
    // private _cache: any = {};
    constructor(dest, parent, key, schema, guidField, options, prevArray, prevIndex) {
        this._cache = (0, vue_1.shallowRef)();
        (0, vue_1.markRaw)(this);
        this.$key = key;
        this._dest = dest;
        this._parent = parent;
        this._schema = schema;
        this._options = options;
        this._guidField = guidField;
        this._prevArray = prevArray;
        this._prevIndex = prevIndex;
        if (options.wrapAll || schema.type !== 'object') {
            this._cache.value = this.$item;
        }
        else {
            this._cache.value = null;
        }
    }
    /**
     * pobranie obiektu reprezentującego wartośc w tablicy
     *
     * @readonly
     * @type {IWrappedProperty}
     * @memberof WrapperPropertyArrayItem
     */
    get $item() {
        if (this._cache.value) {
            return this._cache.value;
        }
        else {
            const obj = new WrappedPropertyCtor_1.WrappedPropertyCtor[this._schema.type]({
                dest: this._dest,
                parent: this._parent,
                propName: this.$key,
                schema: this._schema,
                options: this._options,
                prevModel: this._prevArray && this._prevIndex != undefined && this._prevIndex > -1
                    ? this._prevArray[this._prevIndex]
                    : undefined
            });
            // Object.seal(obj);
            this._cache.value = obj;
            return obj;
        }
    }
    /**
     * wyczyszczenie wewnętrznego cache zawierającego element tablicy
     *
     * @memberof WrapperPropertyArrayItem
     */
    $clearCache() {
        if (this._cache.value) {
            this._cache.value.$destroy();
            this._cache.value = undefined;
            return true;
        }
        return false;
    }
    /**
     * ustawienie $dirty na false ale tylko wtedy gdy jest pobrane
     *
     * @memberof WrapperPropertyArrayItem
     */
    $reset() {
        if (this._cache.value) {
            this._cache.value.$reset();
        }
    }
    /**
     * lista ellentów dotkęniętych przez użytkownika
     *
     * @param {any[]} result
     * @returns
     * @memberof WrapperPropertyArrayItem
     */
    $dirtyList(result) {
        if (this._cache.value) {
            this._cache.value.$dirtyList(result);
        }
        return result;
    }
    /**
     * czyszczenie obiektu
     *
     * @memberof WrapperPropertyArrayItem
     */
    $destroy() {
        this.$clearCache();
    }
    /**
     * ustawienie nowego indeksu w tablicy
     *
     * @param {number} newKey
     * @memberof WrapperPropertyArrayItem
     */
    $setKey(newKey) {
        this.$key = newKey;
        if (this._cache.value) {
            this._cache.value.$changeKey(newKey);
        }
    }
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    beforePathChange() {
        if (this._cache.value) {
            this._cache.value.beforePathChange();
        }
    }
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    afterPathChange() {
        if (this._cache.value) {
            this._cache.value.afterPathChange();
        }
    }
    get $model() {
        return this._parent[this.$key];
    }
    $removeRow() {
        this._dest.$removeRow(this.$key);
    }
    $remove() {
        this._dest.$removeRow(this.$key);
    }
    $moveUp() {
        this._dest.$moveUp(this.$key);
    }
    $moveDown() {
        this._dest.$moveDown(this.$key);
    }
    $clearRow() {
        this._dest.$clearRow(this.$key);
    }
    $clear() {
        this._dest.$clearRow(this.$key);
    }
    get $guid() {
        if (this._guidField)
            return this._parent[this.$key][this._guidField];
    }
    get $diffStatus() {
        if (this._prevIndex == -100)
            return 'del';
        if (!this._prevArray || (this._prevIndex != undefined && this._prevIndex > -1)) {
            return '';
        }
        return 'new';
    }
}
exports.WrapperPropertyArrayItem = WrapperPropertyArrayItem;
//# sourceMappingURL=WrappedPropertyArrayItem.js.map